import React from 'react';
import useTheme from 'branding/theme';
import SkipToContent from '../SkipToContent';
import TabGroup from '../TabGroup';
import HomeLogo from './HomeLogo';
const MainMenu = ({ homePath, children, tabsPosition = 'start', inverted = false, tabsAlign, 
/** everything that's not a tab should go into aside */
aside, styles }) => {
    const { colors } = useTheme();
    const wrapperStyles = {
        ...(inverted && { backgroundColor: colors.brand.primary.alpha })
    };
    const mergedStyles = {
        width: '100%',
        margin: '0 auto',
        maxWidth: '130rem',
        height: '9rem',
        display: 'flex',
        alignItems: 'center',
        ...styles
    };
    const innerWrapperStyles = {
        width: '100%',
        display: 'flex',
        flexDirection: tabsPosition === 'start' && children ? 'row' : 'row-reverse',
        justifyContent: 'space-between'
    };
    return (React.createElement("div", { style: wrapperStyles },
        React.createElement(SkipToContent, null),
        React.createElement("nav", { style: mergedStyles, "aria-label": "Main" },
            React.createElement(HomeLogo, { homePath: homePath, inverted: inverted }),
            React.createElement("div", { style: innerWrapperStyles },
                children && (React.createElement(TabGroup, { inverted: inverted, align: tabsAlign }, children)),
                aside))));
};
export default MainMenu;
//# sourceMappingURL=index.js.map